/* eslint-disable max-len */
// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>


const CUSTOMER_OVERVIEW_START_LOADER = 'CUSTOMER_OVERVIEW_START_LOADER';
const CUSTOMER_OVERVIEW_STOP_LOADER = 'CUSTOMER_OVERVIEW_STOP_LOADER';

const CUSTOMER_OVERVIEW_OPEN_CONFIRM_MODAL = 'CUSTOMER_OVERVIEW_OPEN_CONFIRM_MODAL';
const CUSTOMER_OVERVIEW_CLOSE_CONFIRM_MODAL = 'CUSTOMER_OVERVIEW_CLOSE_CONFIRM_MODAL';

const CUSTOMER_OVERVIEW_CHANGE_REDEEM_VALUE = 'CUSTOMER_OVERVIEW_CHANGE_REDEEM_VALUE';
const CUSTOMER_OVERVIEW_VALIDATE_REDEEM_VALUE = 'CUSTOMER_OVERVIEW_VALIDATE_REDEEM_VALUE';
const CUSTOMER_OVERVIEW_RESET_FORM = 'CUSTOMER_OVERVIEW_RESET_FORM';

const CUSTOMER_OVERVIEW_REDEEM_VOUCHER = 'CUSTOMER_OVERVIEW_REDEEM_VOUCHER';
const CUSTOMER_OVERVIEW_REDEEM_VOUCHER_SUCCESS = 'CUSTOMER_OVERVIEW_REDEEM_VOUCHER_SUCCESS';

const CUSTOMER_OVERVIEW_GET_BOOKSHOP_CUSTOMER = 'CUSTOMER_OVERVIEW_GET_BOOKSHOP_CUSTOMER';
const CUSTOMER_OVERVIEW_GET_BOOKSHOP_CUSTOMER_SUCCESS = 'CUSTOMER_OVERVIEW_GET_BOOKSHOP_CUSTOMER_SUCCESS';

const CUSTOMER_OVERVIEW_WITHDRAWAL_BALANCE_LOG_SUCCESS = 'CUSTOMER_OVERVIEW_WITHDRAWAL_BALANCE_LOG_SUCCESS';


export {
  CUSTOMER_OVERVIEW_START_LOADER,
  CUSTOMER_OVERVIEW_STOP_LOADER,

  CUSTOMER_OVERVIEW_CHANGE_REDEEM_VALUE,
  CUSTOMER_OVERVIEW_VALIDATE_REDEEM_VALUE,
  CUSTOMER_OVERVIEW_RESET_FORM,

  CUSTOMER_OVERVIEW_REDEEM_VOUCHER,
  CUSTOMER_OVERVIEW_REDEEM_VOUCHER_SUCCESS,

  CUSTOMER_OVERVIEW_GET_BOOKSHOP_CUSTOMER,
  CUSTOMER_OVERVIEW_GET_BOOKSHOP_CUSTOMER_SUCCESS,
  CUSTOMER_OVERVIEW_WITHDRAWAL_BALANCE_LOG_SUCCESS,

  CUSTOMER_OVERVIEW_OPEN_CONFIRM_MODAL,
  CUSTOMER_OVERVIEW_CLOSE_CONFIRM_MODAL,
};
